var Analytics = {
  trackEvent: function (category, action, label) {
    if (window.ga) {
      window.ga('send', 'event', category, action, label);
    }
  },

  trackPage: function () {
    var location =
      window.location.protocol +
      '//' +
      window.location.hostname +
      window.location.pathname +
      window.location.search;

    if (window.ga) {
      window.ga('send', 'pageview', {
        location: location,
        title: document.title,
      });
    }
  },
};

module.exports = Analytics;
